import { Directive } from '@angular/core';

@Directive({
  selector: 'ng-template[uiTableRowCollapsible]',
})
export class TableRowCollapsibleDirective {
}
